import { useQuery } from '@tanstack/react-query';

import { categoryTreeQuery } from './categoryTreeQuery';

export const useCategoryTree = () => useQuery(categoryTreeQuery());
